{
	"id": "proethica-modules",
	"title": "Proethica Modules",
	"modules": [
		{
			"moduleRef": "content/modules/module-1.json",
			"icon": "school-outline",
			"displayType": ["Display", "Filter", "Progress"],
			"numItems": 10,
			"defaultStatus": "NOT_STARTED",
			"disabled": false
		},
		{
			"moduleRef": "content/modules/module-2.json",
			"icon": "school-outline",
			"displayType": ["Display", "Filter", "Progress"],
			"numItems": 12,
			"defaultStatus": "NOT_STARTED",
			"disabled": false
		},
		{
			"moduleRef": "content/modules/module-3.json",
			"icon": "school-outline",
			"displayType": ["Display", "Filter", "Progress"],
			"numItems": 10,
			"defaultStatus": "NOT_STARTED",
			"disabled": false
		},
		{
			"moduleRef": "content/modules/module-4.json",
			"icon": "school-outline",
			"displayType": ["Display", "Filter", "Progress"],
			"numItems": 10,
			"defaultStatus": "NOT_STARTED",
			"disabled": false
		},
		{
			"moduleRef": "content/modules/module-5.json",
			"icon": "school-outline",
			"displayType": ["Display", "Filter", "Progress"],
			"numItems": 8,
			"defaultStatus": "NOT_STARTED",
			"disabled": false
		},
		{
			"moduleRef": "content/modules/module-6.json",
			"icon": "school-outline",
			"displayType": ["Display", "Filter", "Progress"],
			"numItems": 10,
			"defaultStatus": "NOT_STARTED",
			"disabled": false
		},
		{
			"moduleRef": "content/modules/module-7.json",
			"icon": "school-outline",
			"displayType": ["Display", "Filter", "Progress"],
			"numItems": 10,
			"defaultStatus": "NOT_STARTED",
			"disabled": false
		},
		{
			"moduleRef": "content/modules/module-8.json",
			"icon": "school-outline",
			"displayType": ["Display", "Filter", "Progress"],
			"numItems": 10,
			"defaultStatus": "NOT_STARTED",
			"disabled": false
		}
	]
}
